var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"terms-of-use-footer"},[_c('a',{attrs:{"href":_vm.termsAndCoditionsUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('common.footer_item.terms_conditions'))+" ")]),_c('a',{attrs:{"href":_vm.privacyPolicyUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('common.footer_item.privacy_policy'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }